import { Link } from 'react-router-dom';
import { Section } from '../ui';

export default function NotFound() {
  return (
    <main>
      <Section lg>
        <span className="eyebrow">Error 404</span>
        <h1 className="h-page" style={{ maxWidth: '18ch' }}>
          Nothing captured here.
        </h1>
        <p className="lede">
          That page does not exist. The work does — start from the top, or tell us what you were
          looking for.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 36 }}>
          <Link className="btn btn--primary" to="/">
            Back to home
          </Link>
          <Link className="btn btn--ghost" to="/contact">
            Contact us
          </Link>
        </div>
      </Section>
    </main>
  );
}
